import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  variant?: "default" | "light";
}

export default function Breadcrumb({ items, variant = "default" }: BreadcrumbProps) {
  const base = variant === "light" ? "text-primary-200" : "text-foreground-500";
  const link = variant === "light" ? "hover:text-accent-300" : "hover:text-primary-600";
  const current = variant === "light" ? "text-white" : "text-foreground-900";
  const sep = variant === "light" ? "text-primary-400" : "text-foreground-400";

  return (
    <nav aria-label="面包屑导航" className={`flex items-center flex-wrap gap-1 text-sm ${base}`}>
      <Link to="/" className={`${link} cursor-pointer flex items-center gap-1`}>
        <i className="ri-home-4-line" aria-hidden="true" />
        首页
      </Link>
      {items.map((item, i) => (
        <span key={`${item.label}-${i}`} className="flex items-center gap-1">
          <i className={`ri-arrow-right-s-line ${sep}`} aria-hidden="true" />
          {item.to ? (
            <Link to={item.to} className={`${link} cursor-pointer`}>
              {item.label}
            </Link>
          ) : (
            <span className={`${current} font-medium`}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}